import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{staticClass:"search-input",attrs:{"placeholder":_vm.$lang.general_SearchPlaceholder,"aria-label":_vm.$lang.general_SearchPlaceholder,"prepend-inner-icon":"$magnify","filled":"","outlined":"","dense":"","hide-details":"","clearable":"","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }